"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _target = _interopRequireDefault(require("./target"));
var _video_clip = _interopRequireDefault(require("./video_clip"));
var _translation_source = _interopRequireDefault(require("./translation_source"));
var _constants = require("@seedlang/constants");
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Translation = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_target["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Translation() {
    var _this;
    _classCallCheck(this, Translation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Translation, [].concat(args));
    // there is also a translation_basic.js
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "type", _descriptor2, _this);
    _initializerDefineProperty(_this, "source", _descriptor3, _this);
    // is this used?
    _initializerDefineProperty(_this, "literalSource", _descriptor4, _this);
    _initializerDefineProperty(_this, "complexity", _descriptor5, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor6, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor7, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "targetText", _descriptor9, _this);
    _initializerDefineProperty(_this, "targetId", _descriptor10, _this);
    _initializerDefineProperty(_this, "wordTypeId", _descriptor11, _this);
    _initializerDefineProperty(_this, "gender", _descriptor12, _this);
    _initializerDefineProperty(_this, "root", _descriptor13, _this);
    _initializerDefineProperty(_this, "useInFeedEntry", _descriptor14, _this);
    _initializerDefineProperty(_this, "target", _descriptor15, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor16, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor17, _this);
    return _this;
  }
  _inherits(Translation, _RootModel);
  return _createClass(Translation, [{
    key: "defaultSource",
    get: function get() {
      var translationSource = this.translationSources.find(function (item) {
        return item["default"];
      });
      return translationSource ? translationSource.source : {};
    }
  }, {
    key: "dictionaryUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.targetText) ? "http://dict.cc?s=".concat(this.targetText.replace(' ', '+')) : null;
    }
  }, {
    key: "wordTypeName",
    get: function get() {
      var wordTypeIdToName = new Map(_constants.Constants.WORD_TYPES.map(function (i) {
        return [i.id, i.name];
      }));
      return (0, _utils.isPresent)(this.wordTypeId) ? wordTypeIdToName.get(this.wordTypeId) : null;
    }
  }, {
    key: "isNoun",
    get: function get() {
      return this.wordTypeId === 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
    }
  }, {
    key: "genderAbbreviation",
    get: function get() {
      var gender = '';
      if (this.gender === 'feminine') {
        gender = ' (f.)';
      } else if (this.gender === 'masculine' && this.languageId === 'NL') {
        gender = ' (c.)';
      } else if (this.gender === 'masculine') {
        gender = ' (m.)';
      } else if (this.gender === 'neuter') {
        gender = ' (n.)';
      }
      return gender;
    }
  }, {
    key: "targetTextWithGenderAndWordType",
    get: function get() {
      return "".concat(this.targetText).concat((0, _utils.isPresent)(this.genderAbbreviation) ? " ".concat(this.genderAbbreviation) : '', " - ").concat(this.wordTypeName);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "source", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "literalSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "complexity", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "targetText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "targetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "wordTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "gender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "root", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "useInFeedEntry", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "target", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "defaultSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dictionaryUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "dictionaryUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordTypeName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordTypeName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNoun"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderAbbreviation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetTextWithGenderAndWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetTextWithGenderAndWordType"), _class.prototype), _class);
var _default = exports["default"] = Translation;